import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import tr from "./locales/tr.json";
import en from "./locales/en.json";
import ru from "./locales/ru.json";

export const LANGS = [
  { code: "tr", label: "TR", name: "Türkçe" },
  { code: "en", label: "EN", name: "English" },
  { code: "ru", label: "RU", name: "Русский" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: { translation: tr },
      en: { translation: en },
      ru: { translation: ru },
    },
    fallbackLng: "tr",
    supportedLngs: ["tr", "en", "ru"],
    interpolation: { escapeValue: false },
    returnObjects: true,
    detection: {
      // Default is always Turkish (no "navigator"). User's manual choice is
      // remembered (localStorage) and ?lng= still works for SEO/hreflang.
      order: ["querystring", "localStorage", "htmlTag"],
      caches: ["localStorage"],
      lookupQuerystring: "lng",
      lookupLocalStorage: "demar_lang",
    },
  });

// Keep <html lang> in sync for SEO / a11y
const applyHtmlLang = (lng) => {
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("lang", lng);
  }
};
applyHtmlLang(i18n.resolvedLanguage || "tr");
i18n.on("languageChanged", applyHtmlLang);

export default i18n;
